import {TAssets} from "./types";

export const assets: TAssets[] = ['employees', 'vendors', 'physicalAssets', 'virtual', 'saas', 'certificate', 'software'];